/**
 * Polymorphic membership key: the same numeric id can belong to both a User and a Client.
 *
 * @param {{ externalScope?: string, externalId?: string }} contact
 * @returns {string}
 */
export function contactIdentityKey(contact) {
  return `${contact.externalScope}:${contact.externalId}`;
}

/**
 * @param {object[]} selectedContacts
 * @returns {{ selected_client_external_ids: string[], selected_user_external_ids: string[] }}
 */
export function selectedParticipantsProperties(selectedContacts) {
  const selectedClientExternalIds = [];
  const selectedUserExternalIds = [];

  selectedContacts.forEach(contact => {
    if (contact.isClient) {
      selectedClientExternalIds.push(contact.externalId);
    } else {
      selectedUserExternalIds.push(contact.externalId);
    }
  });

  return {
    'selected_client_external_ids': selectedClientExternalIds,
    'selected_user_external_ids': selectedUserExternalIds,
  };
}
